<template>

<div class="register-gift-page" v-if="$route.query.activityId">
    <div class="center-container">
      <div class="content">
        <!-- 主标题 -->
        <!-- <div class="main-title">注册有礼，福利多多</div> -->
<!-- type="flex" justify="space-around" -->
        <van-row type="flex" justify="space-between">
          <van-col span="11" class="infoBox">
            <img src="@/assets/image/liwu.png" alt="" class="infoImg">
            <div class="infoTip">注册免费享受年费检索</div>
          </van-col>
          <van-col span="11" class="infoBox">
            <img src="@/assets/image/qian.png" alt="" class="infoImg">
            <div class="infoTip">邀请好友，多邀多得</div>
          </van-col>
        </van-row>
        <!-- 步骤条 -->
        <div class="steps-container">
          <div class="steps-line"></div>
          <van-row type="flex" justify="space-between" class="setpBox">
            <van-col span="8" class="setpInfo">
              <div class="setpNum">1</div>
              <div class="setpTip">微信授权，</div>
              <div class="setpTip">关注服务号</div>

            </van-col>
            <van-col span="8" class="setpInfo">
              <div class="setpNum">2</div>
              <div class="setpTip">填写手机号，</div>
              <div class="setpTip">注册参与</div>
            </van-col>
            <van-col span="8" class="setpInfo">
              <div class="setpNum">3</div>
              <div class="setpTip">填写问卷，</div>
              <div class="setpTip">提交参与</div>
            </van-col>
          </van-row>
        </div>
        <van-button 
            type="primary" 
            block 
            round 
            class="enter-btn"
            @click="startWechatLogin"
          >立即参与</van-button>
        <van-button
            type="default"
            size="small"
            round
            class="follow-btn"
            @click="testfwh"
        >
          关注服务号
        </van-button>
      </div>
    </div>
  </div>
  </template>

  <script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    data(){
        return {
            show: false,
            loading: false,
        }
    },
    computed: {
      ...mapGetters(['companyInfo','userInfo','isLogin'])
    },
    mounted() {
      this.initWechatShare();
      if(this.isLogin){
        if(this.$route.query.activityId) {
          this.$router.push({
            path: '/wenJuan/detailPage',
            query: {
              activityId: this.$route.query.activityId
            }
          });
        } else {
         this.$router.push({
            path: '/wenJuan/listPage',
          });
        }
      }
   },
    methods: {
      ...mapActions(['loginAction']),
      async testfwh() {
        //const bizCode = 'MzIxODgwOTg4Nw==';
        //window.location.href = `https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=${bizCode}&scene=124#wechat_redirect`;
        //window.location.href = `https://mp.weixin.qq.com/s/i_cdbOyy1GdhmYiMzIrftg`;
        window.location.href = `https://mp.weixin.qq.com/s/VyGO6kUa6pOwb-wkPqp76g`;
      //1
      },
      initWechatShare() {
        // 初始化微信分享配置
        window.wx.ready(() => {
          window.wx.updateAppMessageShareData({
            title: '年费布局问答表',
            desc: '快来参与问卷调查，获取丰厚奖励！',
            link: window.location.href,
            imgUrl: window.location.origin+'/img/qian.3ba4df97.png',
            success: () => {
              console.log('分享配置设置成功');
            }
          });
        });
      },
    startWechatLogin() {
      if(this.isLogin){
        if(this.$route.query.activityId) {
          this.$router.push({
            path: '/wenJuan/detailPage',
            query: {
              activityId: this.$route.query.activityId
            }
          });
        } else {
          const  redirect_uri = decodeURIComponent(this.$route.query.redirect_uri);
          console.log('redirect_uri12345',redirect_uri)
          this.$router.push({
            path: '/wenJuan/listPage',
          });
        }
      }else{
        // 微信授权登录
        //let appId = 'wxe8680f410ecb65c4';
        let appId = 'wx9cc9186b5cf570c6';
        let redirectUriUrl = window.location.origin+'/#/publicPage';
        // 检查是否有activityId参数
        if(this.$route.query.activityId) {
          const activityId = this.$route.query.activityId;
          if (activityId != null && activityId != '' && activityId != 'null' && activityId != 'undefined') {
            redirectUriUrl += '?activityId=' + activityId;
          }
        }
        if(this.$route.query.presenter){
          const presenter = this.$route.query.presenter;
          if (presenter != null && presenter != '' && presenter != 'null' && presenter != 'undefined') {
            // 如果有presenter参数，添加到URL中
            if (redirectUriUrl.includes('?')) {
              redirectUriUrl += '&presenter=' + presenter;
            } else {
              redirectUriUrl += '?presenter=' + presenter;
            }
          }
        }
        let redirectUri = encodeURIComponent(redirectUriUrl);
        const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE`;
        window.location.href = authUrl;
      }
    },
    }
  }
  </script>

  <style scoped lang="less">
  .register-gift-page {
  min-height: 100vh;
  background:rgb(248, 248, 252);// linear-gradient(to bottom, #ffecd2, #fcb69f);
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('../assets/image/homeBg.png');
    // padding-top:46px;
    // padding-bottom: 20px;
    background-size: cover;
    background-repeat: no-repeat;
}
.center-container {
  width: 100%;
  // padding: 20px;
  box-sizing: border-box;
}
.content {
  // max-width: 400px; /* 限制内容最大宽度 */
  margin: 0 auto; /* 水平居中 */
  text-align: center;
  margin-top:160px;
  // border:1px solid red;
}

.main-title {
  font-size: 24px;
  color: #824bc3;
  margin-bottom: 30px;
  font-weight: bold;
}

.activity-card {
  background-color: rgb(227, 215, 255);
  border-radius: 12px;
  padding: 20px;
  margin: 30px 0;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.activity-item {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  font-size: 16px;
  color: #824bc3;
  font-weight: 700;
}

// .activity-item .van-icon {
//   margin-right: 10px;
// }

// .register-btn {
//   width: 80%;
//   margin-top: 40px;
//   background: linear-gradient(to right, #ff7676, #f54ea2);
//   border: none;
//   font-size: 18px;
//   font-weight: bold;
// }

.enter-btn {
    width: 100%;
    margin: 0 auto;
    height: 44px;
    font-size: 16px;
    background: #824bc3;
    // background: linear-gradient(to right, #ff6034, #ee0a24);
    border: none;
  }

/* 响应式调整 */
@media (max-width: 480px) {
  .content {
    padding: 0 15px;
  }
  
  .main-title {
    font-size: 22px;
  }
  
  .register-btn {
    width: 90%;
  }
}
.weiXinClass{
  width: 100px;
  height: 100px;
}
.infoBox{
  // display: flex;
  padding:15px 0;
  border-radius: 10px;
  // align-items: center;
  // justify-content: center;
  background: rgb(236 239 244);
}
.infoImg{
  width: 74px;
  height: 74px;
}
.infoTip{
  font-size: 14px;
  margin-top: 10px;
}

.steps-container {
  position: relative;
  margin: 30px 0;
}

    .steps-line {
      position: absolute;
      top: 30px;
      left: 10%;
      width: 80%;
      height: 2px;
      background-color: #824bc3;
      z-index: 1;
    }


.setpBox{
  position: relative;
      z-index: 2;
  // align-items: center;
  // justify-content: center;
}
.setpTip{
  font-size: 12px;
  line-height: 1.4;
}
.setpInfo {
  // border:1px solid blue;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.setpNum{
  border-radius: 50%;
  width: 60px;
  height: 60px;
  line-height: 60px;
  background-color: white;
  color: #824bc3;
  font-weight: bold;
  margin-bottom: 15px;
  border: 2px solid #824bc3;
  box-sizing: border-box;
}.follow-btn {
   width: 100%;
   margin-top: 20px;
   height: 36px;
   font-size: 14px;
   background: #824bc3;
   color: white;
   border: none;

   &::after {
     border: none;
   }
 }

</style>